import numbro from 'numbro'
import React from 'react'
import { View, Text } from 'react-native'
import { Divider } from 'react-native-paper'

type DetailsRowItemProps = {
  leftText?: string
  rightText?: React.ReactNode
  money?: boolean
  onPress?: () => void
}

export const DetailsRowItem: React.FC<DetailsRowItemProps> = ({
  leftText,
  rightText,
  money,
  onPress,
}): JSX.Element => {
  return (
    <>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text style={{ fontSize: 14, fontWeight: '500', color: '#99ADBA' }}>
          {leftText}
        </Text>
        <Text
          style={{ fontSize: 14, fontWeight: '500', color: '#335C75' }}
          onPress={onPress}
        >
          {money
            ? `$${numbro(rightText).format({
                thousandSeparated: true,
                mantissa: 2,
              })}`
            : rightText}
        </Text>
      </View>
      <Divider style={{ marginTop: 14, marginBottom: 14 }} />
    </>
  )
}
